<template>
  <md-content class="md-elevation-2 cta-content">
    <h4 class="earned-title">Total points earned</h4>
    <h3 class="points-amount">
      {{ this.formatPoints(myEarnedPoints) }}
      <img
        class="ml-1 mb-4"
        src="/img/Polygon_7.svg"
        alt="Swampum"
        width="15px"
        height="15px"
      />
    </h3>
  </md-content>
</template>

<script>
import UserHelperVue from "@/mixins/UserHelper.vue";
import PointsHelperVue from "@/mixins/PointsHelper.vue";
export default {
  name: "EarnedPointsCTA",
  mixins: [UserHelperVue, PointsHelperVue],
  created() {
    this.fetchMyEarnedPoints();
  },
};
</script>

<style lang="scss" scoped>
.cta-content {
  max-width: 340px;
  height: fit-content;
  border: 1px solid rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  border-radius: 4px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.earned-title {
  margin-top: 1rem;
}
.points-amount {
  color: $primary;
  font-weight: bold;
  display: flex;
}

</style>
